module.exports = __webpack_public_path__ + "media/images/lp_v6_mv_txt02_01-8ee48332a7d1b4d792af6be3faf2f593.webp";